import React, { useEffect, useState } from "react";
import "./style.scss";
import { useParams } from "react-router-dom";
import { getBlogById } from "../../../../services/cmsPage.service";

const SinglePost = () => {
  const { uuid } = useParams(); // Get uuid from URL
  const [blog, setBlog] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const loadBlog = async () => {
      if (!uuid) return;

      try {
        const data = await getBlogById(uuid as string);

        setBlog(data);
        setLoading(false);
      } catch (err: any) {
        setError(err.message || "Failed to load blog");
        setLoading(false);
      }
    };

    loadBlog();
  }, [uuid]);


  return (
    <>

      {/* ==================== LOADING BELOW BANNER ==================== */}
      {loading ? (
        <section className="py-5 bg-light">
          <div className="container">
            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "50vh" }}>
              <div
                className="spinner-border text-primary"
                role="status"
                style={{ width: "3rem", height: "3rem" }}
              >
                <span className="visually-hidden">Loading…</span>
              </div>
            </div>
          </div>
        </section>
      ) : error ? (
        /* ==================== ERROR BELOW BANNER ==================== */
        <section className="py-5 bg-light">
          <div className="container">
            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "50vh" }}>
              <div className="alert alert-danger text-center p-4" style={{ maxWidth: "500px" }}>
                <h4>Oops! Something went wrong.</h4>
                <p>{error}</p>
              </div>
            </div>
          </div>
        </section>
      ) : (
        <>

          <section className="banner-section">
            <div className="container">
              <div className="row ">
                <div className="col-md-12 ">
                  <div className="main-heading d-flex justify-content-center align-items-center">
                    <h1 className="hero-title">
                      {blog?.title}
                    </h1>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="blog-details-section">
            <div className="container">
              <div className="row g-4">
                <div className="col-md-12 col-lg-12">
                  <div className="blog-detail-image-area mb-5">
                    <img
                      src={blog?.image}
                      alt="Blog Detail Image"
                      width={400}
                      height={250}
                      className="w-100 h-auto"
                    />
                  </div>

                  <div className="blog-detail-text-area">
                    <p className="mb-3">
                     {blog?.content}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>

        </>
      )}
    </>
  );
};

export default SinglePost;
